import InputBox from "../../../../common/interactive/InputBox";
import RadioField from "../../../../common/interactive/RadioField";

export default function SurgicalTab2({classes, activeCase, updateHandler, itemData, apiCase}) {  //######################### Medical Review (semantic step_3_*) - rendered as TAB #2 after the visual swap

    const aprovalOptions = [
        {
            label: 'Surgical Consult Approved',
            value: 1
        },
        {
            label: 'No Further Action Needed',
            value: 2
        },
    ]

    return <div className={classes.drawer_pannel}>
        <h3 className={classes.pannel_title}>#2 Medical Review</h3>
        <div className={classes.drawer_row}>
            <div className={classes.drawer_flex_block}>
                <RadioField fields={aprovalOptions} name={'step_3_approval'} action={updateHandler} identifier={{folder: 'surgeries', type: apiCase, field: 'step_3_approval', type_id: itemData.id}} normalSize={true} defaultChecked={itemData.step_3_approval}/>
            </div>
        </div>
        <div className={classes.drawer_row}>
            <InputBox label={'Provider'} action={updateHandler} currentValue={itemData.step_3_provider} identifier={{folder: 'surgeries', type: apiCase, field: 'step_3_provider', type_id: itemData.id}}/>
        </div>
    </div>
}
